export const getInvitationsInitialState = {
	invitations: undefined,
	loading: false,
	error: null,
	errorShow: false,
	getData: false,
};
